import React, { useState } from 'react';
import { View, Text, TouchableOpacity, ScrollView, StyleSheet, Dimensions, Modal } from 'react-native';
import { useTheme } from '../contexts/ThemeContext';
import { useNavigation } from '@react-navigation/native';

const DashboardSidebar = ({ isOpen, onClose }) => {
  const { colors } = useTheme();
  const navigation = useNavigation();
  const [expanded, setExpanded] = useState(true);

  const screenWidth = Dimensions.get('window').width;
  const isMobile = screenWidth < 768;

  const navigateToDashboardSection = (section) => {
    navigation.navigate('Dashboard', { section, sectionOnly: true });
    if (isMobile) {
      onClose && onClose();
    }
  };

  const navigateToToolsHome = () => {
    navigation.navigate('ToolsHome');
    if (isMobile) {
      onClose && onClose();
    }
  };

  const styles = StyleSheet.create({
    sidebar: {
      width: 280,
      height: '100%',
      backgroundColor: colors.surface,
      borderRightWidth: 1,
      borderRightColor: colors.border,
      paddingTop: 20,
    },
    header: {
      paddingHorizontal: 20,
      paddingBottom: 20,
      borderBottomWidth: 1,
      borderBottomColor: colors.border,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    logo: {
      fontSize: 18,
      fontWeight: 'bold',
      color: colors.text,
    },
    closeButton: {
      padding: 8,
      borderRadius: 20,
      backgroundColor: colors.border,
    },
    closeButtonText: {
      fontSize: 16,
      color: colors.text,
      fontWeight: 'bold',
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 999,
    },
    mobileSidebar: {
      width: Math.min(320, screenWidth * 0.9),
      height: '100%',
      backgroundColor: colors.surface,
      borderRightWidth: 1,
      borderRightColor: colors.border,
    },
    sectionHeader: {
      paddingHorizontal: 20,
      paddingVertical: 12,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottomWidth: 1,
      borderBottomColor: colors.border,
    },
    sectionTitle: {
      fontSize: 14,
      fontWeight: '700',
      color: colors.text,
    },
    expandIcon: {
      fontSize: 12,
      color: colors.textSecondary,
    },
    menuItem: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 10,
      paddingHorizontal: 20,
      borderBottomWidth: 1,
      borderBottomColor: colors.border,
    },
    menuIcon: { marginRight: 10 },
    menuText: { fontSize: 14, color: colors.text },
  });

  const items = [
    { name: 'Invoice Generator', icon: '🧾', onPress: () => navigateToDashboardSection('invoices') },
    { name: 'Quotation Maker', icon: '📄', onPress: () => navigateToDashboardSection('quotations') },
  ];

  if (isMobile) {
    return (
      <Modal visible={!!isOpen} transparent animationType="slide" onRequestClose={onClose}>
        <View style={styles.overlay}>
          <TouchableOpacity style={styles.overlay} activeOpacity={1} onPress={onClose} />
          <View style={styles.mobileSidebar}>
            <View style={styles.header}>
              <Text style={styles.logo}>DASHBOARD</Text>
              <TouchableOpacity onPress={onClose} style={styles.closeButton}>
                <Text style={styles.closeButtonText}>✕</Text>
              </TouchableOpacity>
            </View>
            <ScrollView showsVerticalScrollIndicator={false}>
              <TouchableOpacity style={styles.sectionHeader} onPress={() => setExpanded((e) => !e)}>
                <Text style={styles.sectionTitle}>Tools</Text>
                <Text style={styles.expandIcon}>{expanded ? '▼' : '▶'}</Text>
              </TouchableOpacity>
              {expanded && items.map((it) => (
                <TouchableOpacity key={it.name} style={styles.menuItem} onPress={it.onPress}>
                  <Text style={styles.menuIcon}>{it.icon}</Text>
                  <Text style={styles.menuText}>{it.name}</Text>
                </TouchableOpacity>
              ))}
            </ScrollView>
          </View>
        </View>
      </Modal>
    );
  }

  return (
    <View style={styles.sidebar}>
      <View style={styles.header}>
        <Text style={styles.logo}>DASHBOARD</Text>
        <TouchableOpacity onPress={onClose} style={styles.closeButton}>
          <Text style={styles.closeButtonText}>✕</Text>
        </TouchableOpacity>
      </View>
      <ScrollView showsVerticalScrollIndicator={false}>
        <TouchableOpacity style={styles.sectionHeader} onPress={() => setExpanded((e) => !e)}>
          <Text style={styles.sectionTitle}>Tools</Text>
          <Text style={styles.expandIcon}>{expanded ? '▼' : '▶'}</Text>
        </TouchableOpacity>
        {expanded && items.map((it) => (
          <TouchableOpacity key={it.name} style={styles.menuItem} onPress={it.onPress}>
            <Text style={styles.menuIcon}>{it.icon}</Text>
            <Text style={styles.menuText}>{it.name}</Text>
          </TouchableOpacity>
        ))}
      </ScrollView>
    </View>
  );
};

export default DashboardSidebar;